import { ReactNode } from 'react';
// import { useNavigate } from 'react-router-dom'
// import { isEmpty } from 'lodash';
// import useAuth from '../../hooks/useAuth';

type RoleBasedGuardProp = {
  accessibleRoles: string[];
  children: ReactNode | string;
};

export default function RoleBasedGuard({
  accessibleRoles,
  children,
}: RoleBasedGuardProp) {
  return <>{children}</>;
}
